import { requests } from '@/libs/axios/axios'
import { NotificationEndPoints } from '../notification-endpoints'
import { AxiosResponse } from 'axios'
const getAuditReportsAgainstRandomString = async (randomString: string): Promise<AxiosResponse> => {
  return requests.get(`${NotificationEndPoints.GET_AUDIT_REPORTS_AGAINST_RANDOM_STRING}/${randomString}`)
}
export default getAuditReportsAgainstRandomString
